import t from "./types";
import { Api } from '../../services/httpService';
import { dispatch } from "react-hot-toast";

export const getMerchantBuyerInvoices = (merchantId, buyerPlatformId) => async (dispatch) => {
    const res = await Api('get', `/invoices/unpaid/${merchantId}/${buyerPlatformId}?page=0&size=0`);
    //console.log("getMerchantBuyerInvoices ", res);
    if (res) {
        await dispatch({ type: t.FETCHED_MERCHANT_BUYER_INVOICES, payload: res });
    }
}

export const createInvoice = (params) => async (dispatch) => {
    const res = await Api('post', `/invoices/entry`, params);
    if (res) {
        await dispatch({ type: t.REDIRECT_INVOICE, payload: true })
        await dispatch({ type: t.CREATE_INVOICE, payload: res });
    }
}
export const reSetRedirectFromInvoice = () => async dispatch => {
    await dispatch({ type: t.REDIRECT_INVOICE, payload: false })
}

export const createInvoiceManually = (params) => async (dispatch) => {
    try {
        const res = await Api('post', `/invoices/entry`, params);
        if (res.success === true && params['invoicePDFFile']) {
            let form_data = new FormData();
            form_data.append('file', params.invoicePDFFile, params.invoicePDFFile.name)
            form_data.append('invoicesId', res?.body?.id)
            form_data.append('buyerPlatformsId', params.buyerPlatformId)
            form_data.append("merchantId", params.merchantId);
            dispatch(invoicePdf(form_data));
        }
        if (res.success === true) {
            await dispatch({ type: t.CREATE_INVOICE, payload: res });
        }
        // Handle the error case (failure scenario)
        else if (res.success === false) {
            console.log('res.message', res.message)
            // Optionally handle errors, e.g. set error message to show to the user
            dispatch({ type: t.CREATE_INVOICE_ERROR, payload: res.message });
        }

    } catch (error) {
        // If the request fails or an unexpected error occurs
        dispatch({ type: t.CREATE_INVOICE_ERROR, payload: 'An unexpected error occurred' });
    }
}


export const invoicePdf = (params) => async (dispatch) => {
    for (var key of params.entries()) {
        // console.log('entries2', key[0] + ', ' + key[1]);
    }
    const res = await Api('post', `/invoices/pdf`, params, true);
    // if (res) {
    //     await dispatch({ type: t.INVOICE_PDF, payload: res });
    // }
};


export const getAllTraditionalrequests = (merchantId, buyerPlatformId, status) => async (dispatch) => {
    let res;
    if (status) {
        res = await Api('get', `/traditionalrequests/${merchantId}/${buyerPlatformId}?status=${status}`);
    }
    else {
        res = await Api('get', `/traditionalrequests/${merchantId}/${buyerPlatformId}`);
    }
    if (res) {
        await dispatch({ type: t.GET_ALL_TRADITIONAL_REQUEST, payload: res });
    }
}

export const getAllInvoicesData = (merchantId, buyerPlatformId) => async (dispatch) => {
    //console.log("MerchantId", merchantId);
    //console.log("buyerPlatformId", buyerPlatformId);
    const res = await Api('get', `/invoices/${merchantId}/${buyerPlatformId}`);
    if (res) {
        await dispatch({ type: t.GET_ALL_INVOICES, payload: res });
    }
}



export const getPendingRequests = (merchantId, buyerPlatformId) => async (dispatch) => {
    const res = await Api('get', `/pending/${merchantId}/${buyerPlatformId}`);
    if (res) {
        await dispatch({ type: t.GET_PENDING_REQUESTS, payload: res });
    }
}


export const getPaymentDetails = (userId) => async (dispatch) => {
    const res = await Api('get', `/payments?merchantId=${userId}`);
    if (res) {
        await dispatch({ type: t.GET_PAYMENT_DETAILS, payload: res });
    }
}

export const getSingleInvoice = (invoiceId) => async (dispatch) => {
    const res = await Api('get', `/invoices/${invoiceId}`);
    if (res) {
        await dispatch({ type: t.GET_INVOICE_DETAILS, payload: res });
    }
}

export const getCreateRequestEcommerceData = (merchantId, buyerPlatformId) => async (dispatch) => {
    const res = await Api('get', `/factparam/${merchantId}/${buyerPlatformId}`);
    // console.log("getCreateRequestEcommerceData", res.body.FactParam.advanceLimitcurrency);
    if (res?.body?.FactParam && res?.body?.FactParam.advanceLimitcurrency) {
        localStorage.setItem("@currency", res?.body?.FactParam ? res?.body?.FactParam.advanceLimitcurrency : "");
    } else {
        localStorage.setItem("@currency", "");
    }

    if (res) {
        await dispatch({ type: t.GET_CREATEREQUESTECOMMERCE, payload: res });
    }
    return res;
}


export const verifyInvoiceOtp = (param) => async (dispatch) => {
    const res = await Api('post', `/invoices/validateInvoiceOTP?invUUID=${param['invUUID']}&OTP=${param.OTP}`);
    // console.log(res);
    if (res) {
        await dispatch({ type: t.VERIFY_INVOICE_OTP, payload: res });
    }
}

export const markInvoiceVerify = (param) => async (dispatch) => {
    const res = await Api('post', `/invoices/markInvoiceVerify?invUUID=${param['invUUID']}&OTP=${param.OTP}`, param)
    if (res) {
        await dispatch({ type: t.MARK_INVOICE_VERIFY, payload: res });
    }
}
export const markInvoiceReject = (param) => async (dispatch) => {
    const res = await Api('post', `/invoices/markInvoiceReject?invUUID=${param['invUUID']}&OTP=${param.OTP}&rejectReason=${param.rejectReason}`, param)
    if (res) {
        await dispatch({ type: t.MARK_INVOICE_REJECT, payload: res });
    }
}


export const getInvoiceVerifyStatus = (invUUID) => async (dispatch) => {
    const res = await Api('post', `/invoices/invoiceVerifyStatus?invUUID=${invUUID}`);
    if (res) {
        await dispatch({ type: t.GET_INVOICE_VERIFY_STATUS, payload: res });
    }
}


export const getRequestRecoveries = (requestId) => async (dispatch) => {
    let param = {
        "requestPendingId": requestId,
        "recoveryType": "Request"
    }
    var res = await Api('post', `/pfpclient/recoveries/findAsParam`, param);
    if (res.success) {
        dispatch({ type: t.GET_REQUEST_RECOVERIES_DATA, payload: res?.body })
    } else {
        console.log(res);
    }
}

export const getPendingRecoveries = (pendingId) => async (dispatch) => {
    let param = {
        "requestPendingId": pendingId,
        "recoveryType": "Pending"
    }
    var res = await Api('post', `/pfpclient/recoveries/findAsParam`, param);
    if (res.success) {
        dispatch({ type: t.GET_PENDING_RECOVERIES_DATA, payload: res?.body })
    } else {
        console.log(res);
    }
}


export const getTraditionalRequest = (requestId) => async (dispatch) => {
    let param = {
        "size": 1,
        "page": 0,
        "merchantBuyerPlatformsId": {
            "buyerPlatformsId" : localStorage.getItem("@selectBuyerPlatForm"),
            "merchantId":localStorage.getItem("_id")
        },
        "requestId": requestId
    }
    var res = await Api('post', `/traditionalrequests/findAsParam`, param);
    if (res.success) {
        await dispatch({ type: t.GET_TRADITIONAL_DATA, payload: res?.body })
    } else {

        console.log("Pagination error", res);
    }
}


export const getPaymentDetailById = (paymentId) => async (dispatch) => {
    const res = await Api('get', `/payments/${paymentId}`);
    if (res) {
        dispatch({ type: t.GET_PAYMENTS_DETAILS_BY_ID, payload: res?.body })
    } else {
        console.log("error", res);
    }
}


export const getPaymentDetailsByMerchant = (merchantId, buyerId) => async (dispatch) => {
    const res = await Api('get', `/payments?merchantId=${merchantId}&buyerPlatformsId=${buyerId}`);
    if (res) {
        await dispatch({ type: t.GET_PAYMENT_DETAILS_BYMERCHANT, payload: res });
    }
}





